import { LessonItemFragment } from '../../../types/planung-graphql-client-defs';
import { LessonTableType } from '../TimetableVersion/Table/TimetableVersionLessonsTable';
import { EnrichedLesson } from '../types';

/**
 * Verbindet die Zuordnungen des Backends (für Formulare) mit ihren Tabellen-Zeilen (Anzeige-Felder)
 * zu einem einzigen EnrichedLesson[]-Array.
 *
 * Beide Arrays beschreiben dieselben Zuordnungen – der Join erfolgt über die UUID.
 */
export function enrichLessons(items: LessonItemFragment[], tableLessons: LessonTableType[]): EnrichedLesson[] {
  const tableMap = new Map(tableLessons.map((l) => [l.uuid, l]));

  return items.flatMap((item): EnrichedLesson[] => {
    const table = tableMap.get(item.uuid);
    return table ? [{ ...table, item }] : [];
  });
}
